module.exports = __webpack_public_path__ + "396db0f87b63994bc03765cf6fe0b98f.fbx";